import Lenis from "lenis";
import "lenis/dist/lenis.css";

// Site-wide inertia/eased scrolling. Skipped entirely when the visitor asks for
// reduced motion — native scrolling (and the CSS scroll-behavior fallback) stays.
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

if (!reduceMotion) {
    const lenis = new Lenis({
        lerp: 0.1,
        wheelMultiplier: 1,
        smoothWheel: true,
    });

    const raf = (time) => {
        lenis.raf(time);
        requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);

    // In-page anchors go through Lenis so the eased motion applies to jumps too
    // (Lenis disables the native smooth scroll-behavior while it's running).
    document.addEventListener("click", (e) => {
        const link = e.target.closest('a[href^="#"]');
        if (!link) return;
        const id = link.getAttribute("href");
        if (id.length <= 1) return; // bare "#"
        const target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        lenis.scrollTo(target, { offset: 0 });
    });

    // Expose for other scripts (e.g. a menu that needs to stop/start scrolling).
    window.lenis = lenis;
}
